// assets
import { IconBuildingBridge, IconBuildingCommunity, IconTractor, IconBucket, IconPlug, IconSchool } from '@tabler/icons-react';

// constant
const icons = {
    IconBuildingBridge,
    IconBuildingCommunity,
    IconTractor,
    IconBucket,
    IconPlug,
    IconSchool
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const hhohho = {
    id: 'hhohho',
    title: 'HHOHHO',
    caption: 'Hhohho',
    type: 'group',
    children: [
        {
            id: 'dashboard-hhohho',
            title: 'Dashboard',
            type: 'item',
            url: '/civils/dashboard/hhohho',
            icon: icons.IconDashboard,
            breadcrumbs: false
        },
        {
            id: 'project-overview',
            title: 'Project Overview',
            type: 'collapse',
            icon: icons.IconBuildingBridge,

            children: [
                {
                    id: 'lowLevelCrossing',
                    title: 'Low Level Crossings',
                    type: 'item',
                    url: '/civils/hhohho/low-level-crossing',
                    target: false
                },
                {
                    id: 'footbridges',
                    title: 'Foot Bridges',
                    type: 'item',
                    url: '/civils/hhohho/foot-bridges',
                    target: false
                },
                {
                    id: 'civils',
                    title: 'Roads',
                    type: 'item',
                    url: '/civils/hhohho/roads',
                    target: false
                },
                {
                    id: 'halls',
                    title: 'Commuinity Halls',
                    type: 'item',
                    url: '/civils/hhohho/community-halls',
                    target: false
                }
            ]
        }
    ]
};

export default hhohho;
